import BaseApi from './BaseApi'

class TimetrackingApi extends BaseApi {
  start () {
    return this.post('timetracking/start')
  }

  stop () {
    return this.post('timetracking/stop')
  }

  tracks () {
    return this.get('timetracking/tracks')
  }

  tracksByUser (userId) {
    return this.get(`timetracking/tracks/${userId}`)
  }
}

export default new TimetrackingApi()
